<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
    <button class="returnBtn" @click="back">返回</button>
     <div class="mt-1 container font">   
         <div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="topTitle">选题列表</div>

          <div>
              <div v-if="account!=undefined && account.user_info !=undefined" class="d-flex justify-content align-items-center">
                  <div v-if="account.user_info.imageb!=undefined">
                    <img :src="account.user_info.imageb" class="account_icon">
                  </div>
                  <div class="d-flex flex-row align-items-center">
                      <div>{{account.user_info.nickname}}</div>
                  </div>
            </div>

          </div>
        </div>


        <div class="mt-1 d-flex justify-content align-items-center">
        
          <input type="number" 
                                 v-model="count"
                                
                                 placeholder="请输入想拉取得选题的数量" 
                 />
            <div class="btnAdd" @click="getXuantis(true)"><img src="../assets/icon-edit.png">拉取选题</div>
          
            
          </div>
          <div>拉取选题需要几分钟的时间，请过几分钟后刷新页面，不要重复提交</div>
          <div>确定使用的选题，请点击”选取“</div>
          <div>最多拉取30个选题</div>
          <div v-show="error" class="error-message">{{ error }}</div>   

        <div class="row d-flex justify-content-center">
          <div v-if="xuantis.length==0" class="m-1">暂无选题</div>

          
          <table class="mt-1">
            <tr>
              <th></th>
                    <th>选题</th>
                    <th>选取</th>
            </tr>
            <tr v-for="(xuanti, index) in xuantis" :key="index" class="mt-1" >
                <td style="width: max-content;">{{ index+1 }}</td>
                <td style="text-align: left;">{{xuanti.title}}</td>
                <td> 
                  <div v-if="!xuanti.used">
                    <div class="backBtn" @click="choose(index,true)" v-if="!xuanti.choosen">使用</div>
                    <div style="color:red" class="backBtn" @click="choose(index,false)" v-else>取消</div>
                  </div>
                  <div v-else>已使用</div>
                  <div class="mt-2">
                    <div class="backBtn" @click="delete_item(index)" >删除</div>
                   
                  </div>
                 
                  
                </td>
            </tr>
          </table>
        </div>
            
    
         </div>
   
      
     </div>

     
   </template>
   
   <script>
   
   import GridLoader from 'vue-spinner/src/GridLoader.vue'
   import axios from 'axios';
   import moment from 'moment';

   
   export default {
     data(){


       return {
       
         isLoading:false,
         
         error:'',
         accountId:'',
         account:null,
         xuantis:[],
         spinnerColor:"#262626",
        
         count:5,
        
       }
       
     },
     computed: {
     localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     },
     
     formatDate(){
      return (datetimeString) => {
        console.log(datetimeString)
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD HH:mm:ss');
         return beijingTime
         
       }
     }
   },
   
     components: {
      GridLoader,

     },
      setup(){
        var token=localStorage.getItem('sessionToken')
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
     },
   
   
     mounted(){

      var token=localStorage.getItem('sessionToken')
       
          if(token==undefined || token==null ||token=='')
        {
          this.$router.push('/')
          return
        }
        var role=localStorage.getItem('role')
        if(role!=undefined && role>0)
        {
          this.isAdmin=true
        }
        axios.defaults.headers.common['X-Parse-Session-Token'] = token
       this.accountId = this.$route.params.id;

       this.getXuantis()
     },
     methods:{
     

      back(){
        this.$router.go(-1)
      },
      
        async getXuantis(get_im=false){
         try{
            this.isLoading=true
            if(this.count>30)
            {
              this.error='最多拉取30个选题'
              return
            }
           const response = await axios.get(this.domain+'xhs/get_pre_xuanti?account_id='+this.accountId+'&get_im='+get_im+'&count='+this.count);
          
           var data=response.data
           if(data['status']=='Suc')
           {
               this.xuantis=data['data']
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },

       async choose(index,choosen){
         try{
            this.isLoading=true
            var xuanti_id=this.xuantis[index].objectId
           const response = await axios.get(this.domain+'xhs/choose_xuanti?xuanti_id='+xuanti_id+'&choosen='+choosen);
          
           var data=response.data
           if(data['status']=='Suc')
           {
               this.xuantis[index].choosen=choosen
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },

       async delete_item(index){
         try{
            this.isLoading=true
            var xuanti_id=this.xuantis[index].objectId
           const response = await axios.get(this.domain+'xhs/deleted_xuanti?xuanti_id='+xuanti_id);
          
           var data=response.data
           if(data['status']=='Suc')
           {
              this.xuantis=this.xuantis.filter((_,item)=>item!=index);
               
               
           }
           else
           {
               console.error(data)
               
           }
         }
         catch(error)
         {
             console.error(data)
         }
         finally{
          this.isLoading=false
         }
       },
     }
      
     
   };
   </script>
<style scoped>

.img{
    width:3.5rem;
    border-radius: 0.125rem, 0.125rem,0 0;
}

.card{
  height:max-content;
  min-width: 3rem;
  max-width: 4rem;
}

.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.account_icon{
  width:0.5rem;
  height:0.5rem;
  border-radius: 50%;
}


</style>
   